const baseStyle = {
  control: {
    borderColor: `border`,
  },
  label: {
    color: `heading`,
    cursor: `pointer`,
  },
};

export const Radio = {
  baseStyle,
};
